import React from 'react';

const BlogsContainer = () => {
    return (
        <div className='h-[60vh] flex flex-col justify-center items-center'>
            <h1>ONGOING.. </h1>
            <h2>COMMING SOON</h2>
        </div>
    );
};

export default BlogsContainer;